export class ApiError extends Error {
  constructor(public readonly status:number,public readonly code:string,message:string){super(message);this.name='ApiError';}
}
export class ApiClient {
  constructor(public readonly baseUrl='',private readonly fetcher:typeof fetch=globalThis.fetch.bind(globalThis)){}
  get<T>(path:string):Promise<T>{return this.request(path,'GET');}
  post<T>(path:string,body:unknown,headers?:Record<string,string>):Promise<T>{return this.request(path,'POST',body,headers);}
  delete<T>(path:string):Promise<T>{return this.request(path,'DELETE');}
  private async request<T>(path:string,method:string,body?:unknown,headers?:Record<string,string>):Promise<T>{
    if(!path.startsWith('/api/')||path.includes('://')||path.includes('..'))throw new ApiError(0,'INVALID_PATH','Unsupported API path.');
    let response:Response;
    try{response=await this.fetcher(this.baseUrl+path,{method,credentials:'include',headers:{Accept:'application/json',...(body!==undefined?{'Content-Type':'application/json'}:{}),...headers},...(body!==undefined?{body:JSON.stringify(body)}:{})});}
    catch{throw new ApiError(0,'NETWORK','Cannot reach the game server. Your saved progress is safe; reconnect and try again.');}
    const type=response.headers.get('content-type')??'';
    if(!type.includes('application/json'))throw new ApiError(response.status,'UNAVAILABLE','Online play is unavailable here. You can still play against the computer.');
    const result=await response.json() as {error?:{code?:string;message?:string}};
    if(!response.ok)throw new ApiError(response.status,result.error?.code??'REQUEST_FAILED',result.error?.message??'The request could not be completed.');
    return result as T;
  }
}
/** Custom Electron protocols expose secure random bytes but may omit randomUUID. */
export function requestId():string {
  if(typeof crypto.randomUUID==='function')return crypto.randomUUID();
  const bytes=crypto.getRandomValues(new Uint8Array(16));
  bytes[6]=(bytes[6]!&0x0f)|0x40;
  bytes[8]=(bytes[8]!&0x3f)|0x80;
  const hex=Array.from(bytes,value=>value.toString(16).padStart(2,'0')).join('');
  return `${hex.slice(0,8)}-${hex.slice(8,12)}-${hex.slice(12,16)}-${hex.slice(16,20)}-${hex.slice(20)}`;
}
